module.exports = __webpack_public_path__ + "static/media/4 1 Skrivehastighet Intro.7d5b5cd8.mp3";